export const  verificaCelular = (celular) =>
{    
    return celular.match(/^\(?(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])\)? ?(?:[2-8]|9[1-9])[0-9]{3}-?[0-9]{4}$/);
}
/*
if(!verificaCelular('(11)99999-9999')
{
    console.log('O número informado não é um celular válido!';
}
*/